import React from 'react';

const Prepago = (props) => {
  
    const [selectedPlan, setSelectedPlan] = React.useState(null);

    React.useEffect(() => {
        console.log('PlanPrepago:', props.Gestor.PlanPrepago);
        const updatedPlan = props.Gestor.PlanesVigentes.find(
            (option) => parseInt( option.CODIGO )=== parseInt(props.Gestor.PlanPrepago)
        );
        console.log(updatedPlan);
        setSelectedPlan(updatedPlan);
    }, [props.Gestor.PlanPrepago, props.Gestor.PlanesVigentes]); // Dependencias para sincronizar

   

    return (
        <div className="product-area">
            <h2>Planes Prepago</h2>
            <div className='row'>
                <div className="col-25">
                    <span className="col-form-span">Plan </span>
                    <select id="PlanPrepago" name="PlanPrepago" className="form-group"
                        onChange={ props.Modificar} value={props.Gestor.PlanPrepago}>
                        {props.Gestor.PlanesVigentes.map((option, i) => (
                            <option key={i} value={option.CODIGO}>{option.NOMBRE}</option>
                        ))}
                    </select>
                </div>
                <div className="col-25">
                    <span className="col-form-span">Precio </span>
                    <input type="text" id="MontoPrepago" name="MontoPrepago" disabled autoComplete='off'
                        value={'₡'+(selectedPlan ? selectedPlan.PRECIO.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '')}></input>
                </div>
                <div className="col-25">
                    <span className="col-form-span"># Documentos </span>
                    <input type="text" id="MontoPrepago" name="MontoPrepago" disabled autoComplete='off'
                        value={(selectedPlan ? selectedPlan.DOCUMENTOS : '') + ' x ' + (selectedPlan ? selectedPlan.MESES : '') + ' meses'}></input>
                </div>
                <div className='col-25'>
                    { props.Gestor.VerificacionPaquete[0].Puede === 'NO' ? <>
                    <span className="col-form-span">
                        Haga clic en "Adquirir" para continuar con el proceso de pago.
                    </span>
                    <button onClick={() => props.AdquirirPlan()} >Adquirir</button>
                    </> : <span className="col-form-span"></span>}
                </div>
            </div>
            <span style={{color:'orange'}} className="col-form-span">
{'El plan vence el '+ (selectedPlan && props.Gestor.HoraServidor ? 
                            new Date(new Date(props.Gestor.HoraServidor).setMonth(new Date(props.Gestor.HoraServidor).getMonth() + selectedPlan.MESES))
                                .toLocaleDateString('es-CR', { day: '2-digit', month: '2-digit', year: 'numeric' }) 
                            : '') + ' o cuando haya consumido todos los documentos disponibles. Los documentos no utilizados no son reembolsables. Se cuentan Facturas, Tiquetes, NCs, NDs, FECS (aceptadas), Cotizacione y Pedidos enviados. Por cada 10 compras representa 1 documento del plan.'}
                    </span>
                    <br></br>
                    <h4>Detalle consumo documentos actual</h4>
            <div className='row'>
                <div className="col-100" style={{marginLeft:'10px', marginRight:'30px', marginTop: '20px', color: 'red', fontWeight: 'bold', textAlign: 'left' }}></div>
                <table className="table" style={{ marginLeft:'30px', width: '80%' }}>
                    <thead>
                        <tr>
                            <th>Tipo Documento</th>
                            <th>Número</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.Gestor.ConsumoActual.map((item, index) => (
                            <tr key={index}>
                                <td>{item.TipoDoc}</td>
                                <td>{item.NUM_DOC}</td>
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Prepago;